import { Component, Input } from '@angular/core';
import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';

@Component({
  selector: 'app-bank-data-tab',
  templateUrl: './bank-data.component.html',
  styles: []
})
export class BankDataComponent extends GenericListComponent{
  @Input() public company: any;
  @Input() public mode: string;

  public initBankData(): void {
    this.company.bank_data = { label: '', rib: '', iban: '', bic: '' };
  }
}
